<!-- UPDATED HTML: Add chart container wrapper -->
<div class="row">
  @for (chart of dashboardChartData; track $index; let index = $index) {
  <div class="col-lg-{{colWidth}}">
    <div class="card">
      <!-- Enhanced Card Header with Controls -->
      <div class="card-header d-flex justify-content-between align-items-center">
        <div class="flex-grow-1">
          <h4 class="fs-20 fs-lg-24 mb-1">
            {{ _translate.currentLang == "en" ? chart.titleEn: chart.titleAr}}
            <span ngbTooltip="{{_translate.currentLang == 'en' ? chart.descriptionEn: chart.descriptionAr}}"
              placement="right">
              <img src="/assets/images/svg/icon-info.svg" alt="" class="wh-20">
            </span>
          </h4>
        </div>
        <!--  Chart Control Buttons -->
        <div class="chart-controls d-flex gap-2">
          <!--  Feature 1: Data Labels Toggle -->
          <button type="button" class="btn btn-sm"
            [class]="isDataLabelsEnabled(index) ? 'btn-primary' : 'btn-outline-secondary'"
            (click)="toggleDataLabels(index)" [ngbTooltip]="isDataLabelsEnabled(index) ? 'Hide Values' : 'Show Values'">
            <i class="ri-price-tag-3-line"></i>
          </button>
          <!--  Fix 2: Chart Type Selector with ngbDropdown -->
          <div class="dropdown" ngbDropdown container="body">
            <button class="btn btn-sm btn-outline-secondary" type="button" ngbDropdownToggle
              [ngbTooltip]="getCurrentChartType(index)">
              <i class="mdi mdi-chart-bar"></i>
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
              @for (chartType of getAvailableChartTypesForIndex(index); track chartType.value) {
              <button class="dropdown-item d-flex align-items-center justify-content-between" type="button"
                (click)="changeChartType(index, chartType.value)"
                [class.active]="getCurrentChartType(index) === chartType.value">
                <div class="d-flex align-items-center">
                  <i class="{{chartType.icon}} me-2"></i>
                  {{chartType.label}}
                </div>
                @if (getCurrentChartType(index) === chartType.value) {
                <i class="mdi mdi-check text-success"></i>
                }
              </button>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <!-- CRITICAL FIX: Wrap chart in fixed-size container -->
        <div class="chart-container">
          <apx-chart #chart dir="ltr" class="apex-charts" [chart]="chartData[index]?.chart"
            [series]="chartData[index]?.series" [legend]="chartData[index]?.legend" [stroke]="chartData[index]?.stroke"
            [colors]="chartData[index]?.colors" [fill]="chartData[index]?.fill"
            [dataLabels]="chartData[index]?.dataLabels" [xaxis]="chartData[index]?.xaxis"
            [markers]="chartData[index]?.markers" [plotOptions]="chartData[index]?.plotOptions"
            [yaxis]="chartData[index]?.yaxis" [tooltip]="chartData[index]?.tooltip" [grid]="chartData[index]?.grid"
            [labels]="chartData[index]?.labels">
          </apx-chart>
        </div>
      </div>
    </div>
  </div>
  }
</div>